// extracted by mini-css-extract-plugin
export default {"video-marker":"Uhd3RohayxH8ukeGFBet","video-container":"QfZKQ9W4bOkuMqFduRZP","close-btn":"VpR2YRYFmMn7rswmBGwM","cor-white":"BeZ1OBph3OyYzR3B23nr"};